var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vi-tooltip',{class:(_vm.name + "__icon"),attrs:{"data-testid":"new-feature-badge-index-bmTeL6","hide-delay":400,"placement":_vm.placement,"disabled":!_vm.hintText,"content":_vm.hintText,"effect":"light"}},[_c('badge-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }